import { z } from 'zod';

export const IntercomTeammateSyncResultSchema = z.object({
  teammates: z.number().int().nonnegative(),
});
export type IntercomTeammateSyncResult = z.infer<typeof IntercomTeammateSyncResultSchema>;
